// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G-ad","placeholdersHeader":"styles_placeholdersHeader__2szXk","editorStyle":"styles_editorStyle__3AmBu","placeholdersBox":"styles_placeholdersBox__1FAKE"};